import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormCheck',
    props: {
        value: null,
        options: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const indeterminate = ref(false);
        const currentValue = computed({
            get: () => {
                var _a;
                const val = (_a = props.value) !== null && _a !== void 0 ? _a : [];
                return Array.isArray(val) ? val : [val];
            },
            set: (newValue) => {
                emit("input", newValue);
                if (newValue.length === 0) {
                    selectAll.value = false;
                    indeterminate.value = false;
                }
                else if (newValue.length === props.options.length) {
                    selectAll.value = true;
                    indeterminate.value = false;
                }
                else {
                    indeterminate.value = true;
                }
            },
        });
        const hasOptions = computed(() => {
            return props.options.length > 0;
        });
        const selectAll = ref(false);
        function onSelectAll() {
            if (selectAll.value) {
                const allValues = props.options.map((option) => option[1]);
                emit("input", allValues);
            }
            else {
                emit("input", []);
            }
        }
        return { __sfc: true, props, emit, indeterminate, currentValue, hasOptions, selectAll, onSelectAll };
    }
});
